<stTab id="dashboard" class="dashboard" closePlacement="left" [visible]=true
  [label]="dashboardService.tablePlot == 'table' ? 'Tableaux' : 'Graphiques'">
  <div class="d-flex flex-column h-100">
    <dashboard-table class="flex-grow-1 h-100" *ngIf="isTableAvailable"
      [hidden]="dashboardService.tablePlot != 'table'"></dashboard-table>
    <dashboard-plot class="flex-grow-1 dashboard-body" *ngIf="isPlotAvailable"
      [hidden]="dashboardService.tablePlot != 'plot'"></dashboard-plot>
  </div>
</stTab>